import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/accountaudits', {
			params: searchParams
		})
	}
}
